import { render } from "./ProductBuild.vue?vue&type=template&id=a4408ade&scoped=true"
import script from "./ProductBuild.vue?vue&type=script&lang=js"
export * from "./ProductBuild.vue?vue&type=script&lang=js"

import "./ProductBuild.vue?vue&type=style&index=0&id=a4408ade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4408ade"]])

export default __exports__